<!-- LOADING -->
<lib-ags-loading *ngIf="!listApprenant || !dataApprenantHabilitation"></lib-ags-loading>

<!-- liste des apprenants -->
<div class="synthese-contain" *ngIf="listApprenant && dataApprenantHabilitation">
  <div class="uk-card uk-card-default uk-margin-right uk-margin-medium-bottom">
      <div class="uk-card-header uk-padding-small uk-background-muted">
        <div class="uk-width-expand">
          <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
            Apprenant(s)
          </h3>
        </div>
      </div>
      <kendo-panelbar [expandMode]="expandMode" (stateChange)="getHabilitationApprenant($event)">
        <kendo-panelbar-item
          *ngFor="let apprenant of listApprenant"
          title="{{ apprenant.nom | uppercase }} {{ apprenant.prenom | titlecase }}"
          [id]="apprenant.id_session_apprenant"
        >
          <ng-template kendoPanelBarContent class="uk-margin-bottom">
            <!-- habilitation caces et autorisation de conduite -->
            <ags-habilitation-caces-ac
              *ngIf="
                dataProduitHabilitation[0].habilitation.type === 'CACES' ||
                dataProduitHabilitation[0].habilitation.type === 'AUTORISATION_CONDUITE'
              "
              [infoApprenant]="habilitationApprenant"
              [infoHabilitation]="habilitationInfo"
            ></ags-habilitation-caces-ac>
            <!-- habilitation éléctrique -->
            <ags-habilitation-electrique
              *ngIf="dataProduitHabilitation[0].habilitation.type === 'ELECTRIQUE'"
              [infoApprenant]="habilitationApprenant"
              [infoHabilitation]="habilitationInfo"
            ></ags-habilitation-electrique>
          </ng-template>
        </kendo-panelbar-item>
      </kendo-panelbar>
    </div>
</div>
